export default {
    defaultProps: {
        anchorOrigin: {
            horizontal: "right",
            vertical: "bottom",
        },
    },
};
